"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

require("core-js/modules/es6.function.name");

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _uigTooltipDropdownMenu = _interopRequireDefault(require("@sfly/uig-tooltip-dropdown-menu"));

var _CategoryNavbarElement = _interopRequireDefault(require("./CategoryNavbarElement"));

var _categoryConfig = _interopRequireDefault(require("../categoryConfig"));

var _Utils = _interopRequireDefault(require("../common/util/Utils"));

var _dropdown = _interopRequireDefault(require("@sfly/uig-svg-icon/action/dropdown"));

var _SubCategoryFlyout = require("../components/SubCategoryFlyout");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var MAX_MORE_ELE_DISPLAY_WIDTH = 1200;

var CategoryNavbar = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CategoryNavbar, _React$Component);

  var _super = _createSuper2(CategoryNavbar);

  function CategoryNavbar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CategoryNavbar);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isNavElementPermanentDisplay", function (categoryCode) {
      for (var index = 0; index < _categoryConfig.default.permanentCategory.length; index++) {
        if (categoryCode === "".concat(_categoryConfig.default.permanentCategory[index])) {
          return true;
        }
      }

      return false;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "doAdapt", function (extraContainerSpace) {
      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
          allItems = _assertThisInitialize.allItems,
          moreLi = _assertThisInitialize.moreLi,
          primary = _assertThisInitialize.primary,
          primaryItems = _assertThisInitialize.primaryItems,
          container = _assertThisInitialize.container,
          secondaryItems = _assertThisInitialize.secondaryItems,
          permanentLis = _assertThisInitialize.permanentLis; // if (window.innerWidth >= MAX_MORE_ELE_DISPLAY_WIDTH) {
      //   for (let index = 0; index < primaryItems.length; index++) {
      //     primaryItems[index].classList.remove("hidden");
      //   }
      //   moreLi.classList.add("hidden");
      // } else


      if (typeof window !== 'undefined' && window.innerWidth >= 767
      /*&& window.innerWidth < 1200*/
      ) {
          var extra = typeof extraContainerSpace === 'number' ? extraContainerSpace : 0;
          var moreLiWidth = 56;
          _this.occupiedWidth = moreLiWidth + extra; //moreLi.getBoundingClientRect().width;          

          if (permanentLis) {
            for (var index = 0; index < permanentLis.length; index++) {
              _this.occupiedWidth += permanentLis[index].getBoundingClientRect().width;
            }
          }

          if (allItems) {
            for (var _index = 0; _index < allItems.length; _index++) {
              allItems[_index].classList.remove('hidden');
            }
          }

          var bufferWidth = 5;
          var stopWidth = _this.occupiedWidth + bufferWidth;
          var hideStartIndex = -1;
          var primaryWidth = primary ? primary.getBoundingClientRect().width : 0;

          if (primaryItems) {
            for (var _index2 = 0; _index2 < primaryItems.length; _index2++) {
              var category = _this.props.categories[_index2];

              if (!_this.isNavElementPermanentDisplay(category && category.code)) {
                if (hideStartIndex > -1) {
                  primaryItems[_index2].classList.add('hidden');
                } else if (primaryWidth >= stopWidth + primaryItems[_index2].getBoundingClientRect().width) {
                  stopWidth += primaryItems[_index2].getBoundingClientRect().width;
                } else {
                  if (_index2 == primaryItems.length - 1 && primaryItems[_index2].getBoundingClientRect().width <= moreLiWidth) {
                    stopWidth += primaryItems[_index2].getBoundingClientRect().width;
                  } else {
                    primaryItems[_index2].classList.add('hidden');

                    hideStartIndex = _index2;
                  }
                }
              }
            }
          } // toggle the visibility of More button and items in Secondary List


          if (hideStartIndex === -1) {
            if (moreLi) {
              moreLi.classList.add('hidden');
              moreLi.setAttribute('aria-expanded', false);
            }

            if (container) {
              container.classList.remove('-show-secondary');
            }
          } else if (secondaryItems) {
            for (var _index3 = 0; _index3 < secondaryItems.length; _index3++) {
              var _category = _this.props.categories[_index3];

              var showElement = _this.isNavElementPermanentDisplay(_category && _category.code);

              if (hideStartIndex > _index3 || showElement) {
                secondaryItems[_index3].classList.add('hidden');
              }

              if (!secondaryItems[_index3].classList.contains('hidden')) {
                _this.moreDropdownItems[_category.code] = true;
              } else {
                _this.moreDropdownItems[_category.code] = false;
              }
            }
          }
        }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initializeDOMReferences", function () {
      _this.container = _this.containerRef.current;

      if (_this.container) {
        _this.primary = _this.container.querySelector('.-primary');
        _this.primaryItems = _this.container.querySelectorAll('.-primary > li:not(.more-item)');

        _this.primary.querySelector('.more-item').querySelector('ul').classList.add('-secondary');

        _this.secondary = _this.container.querySelector('.-secondary');
        _this.secondaryItems = _this.secondary.querySelectorAll('li');
        _this.allItems = _this.container.querySelectorAll('li');
        _this.moreLi = _this.primary.querySelector('.more-item');
        _this.permanentLis = _this.primary.querySelectorAll('.permanent-nav-ele');

        _this.doAdapt();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMoreDropDownElementKeyDown", function (event, catIndex) {
      if (catIndex === _this.props.categories.length - 1 && event.keyCode === _Utils.default.keyCodeMap.tab && !event.shiftKey) {
        event.stopPropagation();

        _this.toggleMoreMenu(event, false);
      }

      _Utils.default.handleKeyPress(event, function () {
        _this.setState({
          isMoreExpanded: false,
          highlightMore: false
        });

        if (typeof document !== 'undefined') {
          document.getElementById('cat-link-more').focus();
        }
      }, [_Utils.default.keyCodeMap.escape]);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleMoreMenu", function (e, isEnabled) {
      e.stopPropagation();

      if (!isEnabled) {
        clearTimeout(_this.moreMenuClickCB);

        _this.setState({
          isMoreExpanded: false,
          highlightMore: false
        });
      } else {
        _this.setState({
          highlightMore: true
        }, function () {
          if (_this.state.isMoreExpanded === false) {
            _this.moreMenuClickCB = setTimeout(function () {
              _this.setState({
                isMoreExpanded: true,
                highlightMore: false
              });
            }, 300);
          }
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderMoreDropDownList", function () {
      return _react.default.createElement(_uigTooltipDropdownMenu.default, null, _react.default.createElement("ul", {
        styles: "display:none",
        className: "logged-in-dropdown-list",
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, _this.getMoreDropDownList()));
    });
    _this.state = {
      selectedCategoryId: props.selectedCategoryId,
      isMoreExpanded: false
    };
    _this.containerRef = _react.default.createRef();
    _this.doAdapt = _this.doAdapt.bind((0, _assertThisInitialized2.default)(_this));

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', _this.doAdapt);
    }

    _this.moreMenuClickCB;
    _this.moreDropdownItems = {};
    _this.onCategoryItemKeyPress = _this.onCategoryItemKeyPress.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCategoryLinkDownCB = _this.onCategoryLinkDownCB.bind((0, _assertThisInitialized2.default)(_this));
    _this.checkIfCategoryVisibleInMoreDropDown = _this.checkIfCategoryVisibleInMoreDropDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CategoryNavbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeDOMReferences();
      /**
       * Calling doAdapt method again on window load to fix the
       * initial load issue of subnav elements.
       */

      if (typeof window !== 'undefined' && typeof document !== 'undefined' && document.readyState !== 'complete') {
        window.addEventListener('load', this.doAdapt);
      } else {
        this.doAdapt();
      }

      if (typeof window !== 'undefined') {
        window.addEventListener("orientationchange", this.doAdapt);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if ((0, _stringify.default)(prevProps.categories) !== (0, _stringify.default)(this.props.categories)) {
        this.initializeDOMReferences();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.doAdapt);
        window.removeEventListener('orientationchange', this.doAdapt);
      }
    }
    /**
     * Todo: Handle all key event
     */

  }, {
    key: "getMoreDropDownList",
    value: function getMoreDropDownList() {
      var _this2 = this;

      return this.props.categories.map(function (category, index) {
        return _react.default.createElement("li", {
          key: category.code,
          onClick: function onClick(e) {
            _this2.toggleMoreMenu(e, false);

            _this2.props.onCategoryHover(category, true);
          },
          onKeyDown: function onKeyDown(e) {
            _this2.handleMoreDropDownElementKeyDown(event, index);
          },
          onKeyPress: function onKeyPress(event) {
            event.stopPropagation();

            _Utils.default.handleKeyPress(event, function () {
              _this2.toggleMoreMenu(event, false);

              _this2.props.onCategoryHover(category, true);
            });
          }
        }, _react.default.createElement(_CategoryNavbarElement.default, {
          element: category,
          attr: {
            role: 'button',
            'data-link-id': category.name,
            'data-link-module': 'global-header',
            'data-link-module-type': 'category-nav',
            'data-link-module-position': 'none',
            'data-link-position': index,
            tabIndex: '0'
          }
        }));
      });
    }
  }, {
    key: "onCategoryItemKeyPress",
    value: function onCategoryItemKeyPress(e, category) {
      var _this3 = this;

      var catLink = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!this.props.showFlyout) {
        // Open Flyout
        _Utils.default.handleKeyPress(e, function () {
          _this3.props.onCategoryHover(category, true);
        });
      } else if (this.props.showFlyout && catLink) {
        e.preventDefault(); // prevent other scroll events

        if (typeof window !== 'undefined') {
          window.location.href = catLink;
        }
      }
    }
  }, {
    key: "onCategoryLinkDownCB",
    value: function onCategoryLinkDownCB(e) {
      if (this.props.showFlyout && (e.shiftKey || _Utils.default.filterKeyPress(e, [_Utils.default.keyCodeMap.escape]))) {
        // Close Flyout
        e.stopPropagation();
        this.props.enableFlyout(false);
      }
    }
  }, {
    key: "checkIfCategoryVisibleInMoreDropDown",
    value: function checkIfCategoryVisibleInMoreDropDown(categoryCode) {
      return this.moreDropdownItems[categoryCode];
    }
  }, {
    key: "renderCatList",
    value: function renderCatList() {
      var _this4 = this;

      var _this$props = this.props,
          categories = _this$props.categories,
          selectedCategoryId = _this$props.selectedCategoryId,
          brandType = _this$props.brandType,
          showFlyout = _this$props.showFlyout,
          activeCategory = _this$props.activeCategory,
          flyOutContent = _this$props.flyOutContent;
      var isActiveMoreElement = false; //Enable Flyout for More options category and if more dropdown is closed to avoid postion:relative scenarios

      if (this.moreDropdownItems && activeCategory) {
        if (this.moreDropdownItems[activeCategory.code] && !this.state.isMoreExpanded) {
          isActiveMoreElement = true;
        }
      }

      return _react.default.createElement("nav", {
        "aria-label": "Categories",
        className: "cat-list-container",
        ref: this.containerRef
      }, _react.default.createElement("ul", {
        className: "-primary"
      }, categories.map(function (category, index) {
        var isActiveCat = showFlyout && activeCategory && activeCategory.code === category.code || selectedCategoryId === category.code;
        var isCategoryHovered = showFlyout && activeCategory && activeCategory.code === category.code;
        return _react.default.createElement(_react.default.Fragment, {
          key: category.code
        }, _react.default.createElement("li", {
          id: category.code,
          key: category.code,
          className: "cat-item ".concat(_this4.isNavElementPermanentDisplay(category.code) ? 'permanent-nav-ele' : '', " "),
          onMouseEnter: function onMouseEnter() {
            return _this4.props.onCategoryHover(category, true);
          },
          onMouseLeave: function onMouseLeave() {
            return _this4.props.onCategoryHover(category, false);
          }
        }, _react.default.createElement("div", {
          className: "cat-item-container ".concat(isActiveCat ? 'active-nav-cat' : '', " brand-").concat(_this4.props.brandType, " ")
        }, _react.default.createElement(_CategoryNavbarElement.default, {
          element: category,
          brandType: brandType,
          attr: {
            role: 'link',
            'aria-haspopup': true,
            'aria-expanded': isActiveCat,
            'data-link-id': category.name,
            'data-link-module': 'global-header',
            'data-link-module-type': 'category-nav',
            'data-link-module-position': 'none',
            'data-link-position': index,
            tabIndex: '0',
            id: "cat-link-".concat(category.code)
          },
          onCategoryLinkKeyPressCB: function onCategoryLinkKeyPressCB(e, catLink) {
            return _this4.onCategoryItemKeyPress(e, category, catLink);
          },
          onCategoryLinkDownCB: _this4.onCategoryLinkDownCB
        })), isCategoryHovered && _react.default.createElement(_SubCategoryFlyout.SubCategoryFlyout, (0, _extends2.default)({}, _this4.props, {
          enableFlyout: _this4.props.enableFlyout,
          flyOutContent: flyOutContent,
          showFlyout: _this4.props.showFlyout,
          activeCategory: _this4.props.activeCategory,
          forceCloseSubCategoryFlyout: _this4.props.forceCloseSubCategoryFlyout
        }))));
      }), _react.default.createElement("li", {
        key: "cat-more-item",
        id: "cat-more-item",
        className: "cat-item more-item ".concat(this.state.isMoreExpanded ? 'relative-position' : ''),
        onClick: function onClick(e) {
          _this4.toggleMoreMenu(e, !_this4.state.isMoreExpanded);
        },
        onMouseEnter: function onMouseEnter(e) {
          _this4.toggleMoreMenu(e, true);
        },
        onMouseLeave: function onMouseLeave(e) {
          _this4.toggleMoreMenu(e, false);
        },
        onKeyDown: function onKeyDown(event) {
          if (event.target.id === "cat-link-more" && (event.shiftKey || _Utils.default.filterKeyPress(event, [_Utils.default.keyCodeMap.escape]))) {
            event.stopPropagation();
            _this4.state.isMoreExpanded && _this4.toggleMoreMenu(event, false);
            _this4.props.showFlyout && _this4.props.forceCloseSubCategoryFlyout();
          }
        }
      }, _react.default.createElement("div", {
        className: "cat-item-container ".concat(this.state.highlightMore ? 'active-nav-cat' : '', " brand-").concat(this.props.brandType, " "),
        onKeyPress: function onKeyPress(event) {
          _Utils.default.handleKeyPress(event, function () {
            _this4.toggleMoreMenu(event, !_this4.state.isMoreExpanded);
          });
        }
      }, _react.default.createElement(_CategoryNavbarElement.default, {
        className: 'more-element',
        element: {
          name: 'More',
          icon: _dropdown.default
        },
        brandType: brandType,
        attr: {
          role: 'button',
          'aria-haspopup': true,
          'aria-expanded': this.state.isMoreExpanded,
          tabIndex: '0',
          id: "cat-link-more"
        }
      }), _react.default.createElement("div", {
        id: "moreDropDownContainer",
        className: this.state.isMoreExpanded ? '' : 'hidden'
      }, this.renderMoreDropDownList())), isActiveMoreElement && flyOutContent && _react.default.createElement(_SubCategoryFlyout.SubCategoryFlyout, (0, _extends2.default)({}, this.props, {
        enableFlyout: this.props.enableFlyout,
        flyOutContent: flyOutContent,
        showFlyout: this.props.showFlyout,
        activeCategory: this.props.activeCategory,
        forceCloseSubCategoryFlyout: this.props.forceCloseSubCategoryFlyout
      })))));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.categories) return _react.default.createElement("div", null);
      return _react.default.createElement(_react.default.Fragment, null, this.renderCatList());
    }
  }]);
  return CategoryNavbar;
}(_react.default.Component);

exports.default = CategoryNavbar;